import { render, staticRenderFns } from "./merchantStore.vue?vue&type=template&id=b1ab7fa0"
import script from "./merchantStore.vue?vue&type=script&lang=js"
export * from "./merchantStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports